import { api } from "..";

const endpoint = "/api/inventory-tags";

export interface GenerateInventoryTagsRequest {
  warehouseIds: number[];
  emptyTagsCount: number;
  companyId: number;
}

export interface GenerateSingleInventoryTagRequest {
  companyId: number;
  productCode?: string;
  description?: string;
  unit?: string;
  warehouseName?: string;
  countType?: string; // "PRIMER" or "SEGUNDO"
  consecutiveCode?: string;
}

export interface ReprintInventoryTagsRequest {
  codes: string[];
}

export interface InventoryTagResponse {
  id: number;
  code: string;
  productId: number;
  warehouseId: number;
}

export const generateInventoryTags = async (data: GenerateInventoryTagsRequest) => {
  return await api.post(`${endpoint}/generate`, data, {
    responseType: "blob",
  });
};

export const generateSingleInventoryTag = async (data: GenerateSingleInventoryTagRequest) => {
  return await api.post(`${endpoint}/generate-single`, data, {
    responseType: "blob",
  });
};

export const reprintInventoryTags = async (data: ReprintInventoryTagsRequest) => {
  return await api.post(`${endpoint}/reprint`, data, {
    responseType: "blob",
  });
};

export const getTagsByWarehouse = async (warehouseId: number, companyId: number, productIds?: number[]) => {
  const params: any = { companyId };
  if (productIds && productIds.length > 0) {
    params.productIds = productIds.join(",");
  }
  return await api.get<InventoryTagResponse[]>(`${endpoint}/by-warehouse/${warehouseId}`, { params });
};

